import React from 'react';

import { Text } from '@/components/typography/text';
import {
  AgentConfigGlobalContexts,
  AgentConfigStep,
  AgentConfigStepInputs
} from '@/types/agent';

import PaneGlobalContexts from './paneGlobalContext';
import PaneInputs from './paneInput';


export type PanelStartProps = {
  editable: boolean;
  globalContext?: AgentConfigGlobalContexts;
  onChangeContext: ( context: AgentConfigGlobalContexts ) => void;
  onChangeFirstRoute: ( e: React.ChangeEvent<HTMLSelectElement> ) => void;
  onChangeInputs: ( inputs: AgentConfigStepInputs ) => void;
  step: AgentConfigStep;
  stepNames: string[];
};

const PanelStart = React.memo( function PanelStart( {
  editable,
  globalContext = {},
  onChangeContext,
  onChangeFirstRoute,
  onChangeInputs,
  step,
  stepNames
}: PanelStartProps ) {
  return (
    <>
      <div className='configPane' data-testid='config-edit-panel-start'>
        <strong>Starting Node</strong>
        <br />
        <Text as='label' size='sm' htmlFor='firstStep'>First Step</Text>
        <select
          data-testid='config-edit-panel-start-route-select'
          disabled={ !editable }
          id='firstStep'
          onChange={ onChangeFirstRoute }
          value={ step.routes.default.step }
        >
          <option>-</option>
          {
            stepNames.map(
              ( stepId: string ) => (
                <option key={ stepId } value={ stepId }>
                  { stepId }
                </option>
              )
            )
          }
        </select>
        <br />
      </div>
      <PaneInputs
        data-testid='config-edit-panel-start-inputs'
        editable={ editable }
        inputs={ step.inputs }
        onInputsChange={ onChangeInputs }
        stepId={ step.id }
        stepType={ step.type }
      />
      <PaneGlobalContexts
        data-testid='config-edit-panel-start-contexts'
        editable={ editable }
        globalContext={ globalContext }
        onContextsChange={ onChangeContext }
        stepType={ step.type }
      />
    </>
  );
} );

export default PanelStart;
